
import React, { ReactNode } from 'react';
import Navbar from './Navbar';
import { Toaster } from '@/components/ui/toaster';
import { Toaster as Sonner } from '@/components/ui/sonner';
import { useIsMobile } from '@/hooks/use-mobile';
import MobileNavbar from './MobileNavbar';

interface LayoutProps {
  children: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const isMobile = useIsMobile();
  
  return (
    <div className="flex flex-col min-h-screen w-full overflow-hidden">
      <Navbar />
      <main className={`flex-1 pb-8 mt-16 w-full max-w-full overflow-x-hidden ${isMobile ? 'pb-24 mobile-safe-bottom' : 'pb-8'}`}>
        {children}
      </main>
      {isMobile && <MobileNavbar />}
      <Toaster />
      <Sonner theme="light" expand={true} position="top-center" closeButton richColors />
    </div>
  );
};

export default Layout;
